import { render, staticRenderFns } from "./invitation_detail.vue?vue&type=template&id=4242a42c&scoped=true"
import script from "./invitation_detail.vue?vue&type=script&lang=ts"
export * from "./invitation_detail.vue?vue&type=script&lang=ts"
import style0 from "./invitation_detail.vue?vue&type=style&index=0&id=4242a42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242a42c",
  null
  
)

export default component.exports